import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import ChartCard, { TOOLTIP_STYLE } from "@/components/charts/ChartCard";

export default function LeadTrendChart({ data = [], className, testid = "lead-trend-chart" }) {
  const total = data.reduce((s, d) => s + d.leads, 0);
  return (
    <ChartCard title="Lead trend" subtitle={`${total} leads created in the selected period`} testid={testid} className={className}
      empty={data.length === 0 ? "No lead data for this period" : null}>
      <ResponsiveContainer width="100%" height={260}>
        <AreaChart data={data} margin={{ top: 8, right: 8, left: -18, bottom: 0 }}>
          <defs>
            <linearGradient id="leadFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#0D9488" stopOpacity={0.35} />
              <stop offset="100%" stopColor="#0D9488" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" />
          <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#64748B" }} minTickGap={16} />
          <YAxis allowDecimals={false} tick={{ fontSize: 12, fill: "#64748B" }} />
          <Tooltip contentStyle={TOOLTIP_STYLE} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Area type="monotone" dataKey="leads" name="Leads" stroke="#0D9488" strokeWidth={2} fill="url(#leadFill)" />
          <Area type="monotone" dataKey="converted" name="Converted" stroke="#0B192C" strokeWidth={2} fill="transparent" />
        </AreaChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
